import { orderConstants, globalConstants } from "../../constants";

const initialState = {
  ordersData: [],
  orderStatuses: []
};

const Order = (state = initialState, action) => {
  switch (action.type) {
      case orderConstants.GET_ORDERS + globalConstants.SUCCESS: {
      const data = action.data;
      return {
        ...state,
        ordersData: Array.isArray(data)
          ? data
          : typeof data === 'object' && data !== null
          ? [data]
          : [],
      };
    }

    case orderConstants.GET_ORDER_STATUSES + globalConstants.SUCCESS: {
      return {
        ...state,
        orderStatuses: action.data.statuses
      };
    }
    
    default:
      return state;
  }
};

export default Order;
